import React from "react";
import BackToTop from "../BackToTop";
import Breadcrumbs from "../Breadcrumbs";
import Footer from "../Footer";
import Header from "../PagesHeader";
import RequestModal from "../RequestModal";
import SearchPopup from "../SearchPopup";
import BreadcrumbsData from "../breadcrumbs.json";
import Content from "./Content";

const RSE = () => {
  return (
    <>
      <Header />
      <Breadcrumbs
        title={BreadcrumbsData.rse.title}
        description={BreadcrumbsData.rse.description}
      />
      <Content />
      <Footer />
      <SearchPopup />
      <RequestModal />
      <BackToTop />
    </>
  );
};

export default RSE;
